import styled from "@emotion/styled";

import { zIndexes } from "@skilitics/designer-ui-components";
import {
  Feedback,
  getOverlayResizeHandles,
  useDraggable,
  type HandleGeometry,
  type OverlayGeometry,
  type ResizeHandle,
} from "@skilitics/drag-drop";

import { createResizeableId } from "../dnd/index.ts";

const HandleZone = styled.div`
  position: absolute;
  z-index: ${zIndexes.composableNodeBorderSelected + 1};
  background: transparent;
  touch-action: none;
`;

const HandleContainer = styled.div`
  pointer-events: none;

  ${HandleZone} {
    pointer-events: auto;
  }
`;

type DraggableResizeHandleProps = {
  handle: ResizeHandle;
  nodeId: number;
  cursor: string;
  style: HandleGeometry;
};

const DraggableResizeHandle = ({ handle, nodeId, cursor, style }: DraggableResizeHandleProps) => {
  const { ref } = useDraggable({
    id: createResizeableId(`node-${handle}`, nodeId),
    plugins: [Feedback.configure({ feedback: "none" })],
  });

  return (
    <HandleZone
      ref={ref}
      style={{ ...style, cursor }}
      onClick={(e) => e.stopPropagation()} // Prevent clicks from selecting parent containers
      onMouseOver={(e) => e.stopPropagation()} // Prevent parent hover effects when hovering resize handles
    />
  );
};

type ResizeHandlesProps = {
  nodeId: number;
  geometry: OverlayGeometry;
};

export const ResizeHandles = ({ nodeId, geometry }: ResizeHandlesProps) => {
  const handles = getOverlayResizeHandles(geometry);
  return (
    <HandleContainer style={geometry.overlayStyle}>
      {handles.map(({ handle, cursor, geometry: handleGeometry }) => (
        <DraggableResizeHandle key={handle} handle={handle} nodeId={nodeId} cursor={cursor} style={handleGeometry} />
      ))}
    </HandleContainer>
  );
};
